// extracted by mini-css-extract-plugin
var _1 = "OrdersListStyle-module__amount-info___zYXAq";
var _2 = "OrdersListStyle-module__amount-info___zYXAq";
var _3 = "OrdersListStyle-module__btn-cancel___qRMij";
var _4 = "OrdersListStyle-module__btn-disabled___RtZdo";
var _5 = "OrdersListStyle-module__btn-holder___sMgzD";
var _6 = "OrdersListStyle-module__btn-cancel___qRMij";
var _7 = "OrdersListStyle-module__btn-disabled___RtZdo";
var _8 = "OrdersListStyle-module__btn-holder___sMgzD";
var _9 = "OrdersListStyle-module__buy-container___Y08xP";
var _a = "OrdersListStyle-module__buy-header___oKA5L";
var _b = "OrdersListStyle-module__buy-container___Y08xP";
var _c = "OrdersListStyle-module__buy-header___oKA5L";
var _d = "OrdersListStyle-module__checkbox___IkRXl";
var _e = "OrdersListStyle-module__icon-container___nh_Ol";
var _f = "OrdersListStyle-module__icon-container___nh_Ol";
var _10 = "OrdersListStyle-module__make-order___XZSPy";
var _11 = "OrdersListStyle-module__make-order___XZSPy";
var _12 = "OrdersListStyle-module__my-orders___BSH9K";
var _13 = "OrdersListStyle-module__my-orders___BSH9K";
var _14 = "OrdersListStyle-module__no-content-container___fBXuv";
var _15 = "OrdersListStyle-module__no-content-container___fBXuv";
var _16 = "OrdersListStyle-module__notice___fbogh";
var _17 = "OrdersListStyle-module__orders-headline___fMvsq";
var _18 = "OrdersListStyle-module__orders-item___HP1Pe";
var _19 = "OrdersListStyle-module__orders-item-name___snh2F";
var _1a = "OrdersListStyle-module__orders-list___yOPQy";
var _1b = "OrdersListStyle-module__orders-list-half___AIXoJ";
var _1c = "OrdersListStyle-module__orders-list-matched-orders___lrlFV";
var _1d = "OrdersListStyle-module__orders-list-my-orders___X9LPh";
var _1e = "OrdersListStyle-module__orders-headline___fMvsq";
var _1f = "OrdersListStyle-module__orders-item___HP1Pe";
var _20 = "OrdersListStyle-module__orders-item-name___snh2F";
var _21 = "OrdersListStyle-module__orders-list___yOPQy";
var _22 = "OrdersListStyle-module__orders-list-half___AIXoJ";
var _23 = "OrdersListStyle-module__orders-list-matched-orders___lrlFV";
var _24 = "OrdersListStyle-module__orders-list-my-orders___X9LPh";
var _25 = "OrdersListStyle-module__reset-whitespace___vfvgf";
var _26 = "OrdersListStyle-module__reset-whitespace___vfvgf";
var _27 = "OrdersListStyle-module__sell-btn___etqnu";
var _28 = "OrdersListStyle-module__sell-btn___etqnu";
var _29 = "OrdersListStyle-module__sold-out___J6yL0";
var _2a = "OrdersListStyle-module__sold-out___J6yL0";
var _2b = "OrdersListStyle-module__table___CjMCz";
var _2c = "OrdersListStyle-module__table-body___d6SxY";
var _2d = "OrdersListStyle-module__table-container___ewm0m";
var _2e = "OrdersListStyle-module__table-head___tYUsi";
var _2f = "OrdersListStyle-module__table-head-row___R0Sgu";
var _30 = "OrdersListStyle-module__table-header___dPVGl";
var _31 = "OrdersListStyle-module__table-item___xnUuO";
var _32 = "OrdersListStyle-module__table-label___L5Iu_";
var _33 = "OrdersListStyle-module__table-row___HLB0e";
var _34 = "OrdersListStyle-module__table-body___d6SxY";
var _35 = "OrdersListStyle-module__table-container___ewm0m";
var _36 = "OrdersListStyle-module__table-head___tYUsi";
var _37 = "OrdersListStyle-module__table-head-row___R0Sgu";
var _38 = "OrdersListStyle-module__table-header___dPVGl";
var _39 = "OrdersListStyle-module__table-item___xnUuO";
var _3a = "OrdersListStyle-module__table-label___L5Iu_";
var _3b = "OrdersListStyle-module__table-row___HLB0e";
var _3c = "OrdersListStyle-module__trade-btn___L2_X0";
var _3d = "OrdersListStyle-module__trade-btn___L2_X0";
var _3e = "OrdersListStyle-module__trades-header___w6CzD";
var _3f = "OrdersListStyle-module__trades-header___w6CzD";
export { _1 as "amount-info", _2 as "amountInfo", _3 as "btn-cancel", _4 as "btn-disabled", _5 as "btn-holder", _6 as "btnCancel", _7 as "btnDisabled", _8 as "btnHolder", _9 as "buy-container", _a as "buy-header", _b as "buyContainer", _c as "buyHeader", _d as "checkbox", _e as "icon-container", _f as "iconContainer", _10 as "make-order", _11 as "makeOrder", _12 as "my-orders", _13 as "myOrders", _14 as "no-content-container", _15 as "noContentContainer", _16 as "notice", _17 as "orders-headline", _18 as "orders-item", _19 as "orders-item-name", _1a as "orders-list", _1b as "orders-list-half", _1c as "orders-list-matched-orders", _1d as "orders-list-my-orders", _1e as "ordersHeadline", _1f as "ordersItem", _20 as "ordersItemName", _21 as "ordersList", _22 as "ordersListHalf", _23 as "ordersListMatchedOrders", _24 as "ordersListMyOrders", _25 as "reset-whitespace", _26 as "resetWhitespace", _27 as "sell-btn", _28 as "sellBtn", _29 as "sold-out", _2a as "soldOut", _2b as "table", _2c as "table-body", _2d as "table-container", _2e as "table-head", _2f as "table-head-row", _30 as "table-header", _31 as "table-item", _32 as "table-label", _33 as "table-row", _34 as "tableBody", _35 as "tableContainer", _36 as "tableHead", _37 as "tableHeadRow", _38 as "tableHeader", _39 as "tableItem", _3a as "tableLabel", _3b as "tableRow", _3c as "trade-btn", _3d as "tradeBtn", _3e as "trades-header", _3f as "tradesHeader" }
